/* ============================================================
   LUMIÈRE MAIN INTERACTIONS - SIMPLIFIED
   ============================================================ */

(function() {
  'use strict';

  let morningActive = false;
  let canvas = null;
  let ctx = null;
  let stars = [];
  let particles = [];
  let animationId = null;

  // Initialize canvas
  function initCanvas() {
    canvas = document.getElementById('lm-star-canvas');
    if (!canvas) {
      console.log('Canvas not found');
      return;
    }
    
    ctx = canvas.getContext('2d');
    resizeCanvas();
    createStars();
    createParticles();
    animate();
    window.addEventListener('resize', handleResize);
    console.log('Canvas initialized');
  }

  function resizeCanvas() {
    if (!canvas) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function handleResize() {
    resizeCanvas();
    createStars();
    createParticles();
  }

  function createStars() {
    if (!canvas) return;
    stars = [];
    const area = canvas.width * canvas.height;
    const count = Math.min(Math.floor(area / 4500), 300);
    
    for (let i = 0; i < count; i++) {
      let x, y;
      const side = Math.random();
      
      if (side < 0.3) {
        x = Math.random() * canvas.width * 0.25;
        y = Math.random() * canvas.height;
      } else if (side < 0.6) {
        x = canvas.width * 0.75 + Math.random() * canvas.width * 0.25;
        y = Math.random() * canvas.height;
      } else if (side < 0.8) {
        x = Math.random() * canvas.width;
        y = Math.random() * canvas.height * 0.3;
      } else {
        x = Math.random() * canvas.width;
        y = canvas.height * 0.7 + Math.random() * canvas.height * 0.3;
      }
      
      stars.push({
        x: x, y: y,
        r: Math.random() * 1.6 + 0.3,
        alpha: Math.random() * 0.7 + 0.2,
        delta: (Math.random() - 0.5) * 0.008
      });
    }
  }

  function createParticles() {
    if (!canvas) return;
    particles = [];
    for (let i = 0; i < 18; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 4 + 1,
        alpha: Math.random() * 0.4,
        delta: (Math.random() - 0.5) * 0.004
      });
    }
  }

  function drawStars() {
    if (!ctx || !canvas) return;
    
    for (const star of stars) {
      star.alpha += star.delta;
      if (star.alpha > 0.9 || star.alpha < 0.2) {
        star.delta *= -1;
      }
      ctx.beginPath();
      ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(230, 220, 200, ${star.alpha.toFixed(2)})`;
      ctx.fill();
    }
  }

  function drawParticles() {
    if (!ctx || !canvas) return;
    
    for (const particle of particles) {
      particle.alpha += particle.delta;
      if (particle.alpha > 0.5 || particle.alpha < 0) {
        particle.delta *= -1;
      }
      const gradient = ctx.createRadialGradient(particle.x, particle.y, 0, particle.x, particle.y, particle.r * 3.5);
      gradient.addColorStop(0, `rgba(200, 169, 110, ${particle.alpha.toFixed(2)})`);
      gradient.addColorStop(1, 'transparent');
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, particle.r * 3.5, 0, Math.PI * 2);
      ctx.fillStyle = gradient;
      ctx.fill();
    }
  }

  function draw() {
    if (!ctx || !canvas) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawStars();
    drawParticles();
  }

  function animate() {
    draw();
    animationId = requestAnimationFrame(animate);
  }

  // ============================================================
  // MORNING TRANSITION - Toggle between night and morning
  // ============================================================
  function activateMorning() {
    if (morningActive) {
      console.log('Morning already active');
      return;
    }
    
    console.log('Activating morning transition...');
    morningActive = true;
    
    // Add morning class to body - this triggers CSS transitions
    // Moon hides, Sun appears, Birds appear, colors change
    document.body.classList.add('morning');
    
    // Hide the prebook button
    const prebookBtn = document.querySelector('.hero-cta');
    if (prebookBtn) {
      prebookBtn.classList.add('hidden');
    }
    
    // Show form after delay
    setTimeout(() => {
      const formSection = document.querySelector('.luxury-form, #form-section, [data-form-section]');
      if (formSection) {
        formSection.classList.add('visible');
        formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 900);
  }

  // ============================================================
  // ATTACH EVENT LISTENER TO BUTTON
  // ============================================================
  function attachButtonListener() {
    const button = document.querySelector('.hero-cta');
    if (button && !button.hasAttribute('data-listener-attached')) {
      button.setAttribute('data-listener-attached', 'true');
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Pre-book button clicked!');
        activateMorning();
      });
      console.log('Attached listener to hero button');
    }
  }

  // ============================================================
  // INITIALIZE EVERYTHING
  // ============================================================
  function init() {
    console.log('Lumière initializing...');
    initCanvas();
    attachButtonListener();
    
    const observer = new MutationObserver(function() {
      attachButtonListener();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Expose global functions
  window.activateMorningTransition = activateMorning;
  window.Lumière = {
    activateMorning: activateMorning,
    isMorningActive: () => morningActive
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  console.log('Lumière script loaded');
})();